import { Link } from "react-router-dom";

import { useUser } from "@/context/user-context";

import { useKeepRelevantParams } from "../../hooks/useKeepRelevantParams";

export const NavigationLink = ({
  to,
  children,
}: {
  to: string;
  children: React.ReactNode;
}) => {
  const keepRelevantParams = useKeepRelevantParams();
  const userContext = useUser();

  // Check if the URL is external (starts with http/https)
  const isExternal = to.startsWith("http://") || to.startsWith("https://");

  if (isExternal) {
    return (
      <a
        className="flex items-center gap-2"
        href={to}
        target="_blank"
        rel="noopener noreferrer"
      >
        {children}
      </a>
    );
  }

  return (
    <Link
      className="flex items-center gap-2"
      to={`/workspace/${userContext!.activeWorkspace
        ?.id}/${to}?${keepRelevantParams()}`}
    >
      {children}
    </Link>
  );
};
